export const dateTimeConstants = {
    DEFAULT_DATE_FORMAT: 'dd/MM/yyyy',
    DEFAULT_TIME_FORMAT: 'HH:mm',
} as const

export const dateTimeFormatOptionsConstants = {
    DEFAULT_DATE_TIME: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    },
    DATE_ONLY: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    },
} as const
